import { render } from "./NewsMaster.vue?vue&type=template&id=e230e184&scoped=true"
import script from "./NewsMaster.vue?vue&type=script&lang=js"
export * from "./NewsMaster.vue?vue&type=script&lang=js"

import "./NewsMaster.vue?vue&type=style&index=0&id=e230e184&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e230e184"]])

export default __exports__